import axios from "axios";
import { useState } from "react";
import axiosOnSuccessEvent from "utils/axiosOnSuccessEvent";
import removeDoubleSlashes from "utils/removeDoubleSlashes";

export interface EmailSignupProps {
    NewsletterEmail: string;
}

const useEmailSignup = () => {
    const [error, setError] = useState(false);

    const handleAPICall = async (data: EmailSignupProps): Promise<void> => {
        try {
            const form = new FormData();

            form.append("NewsletterEmail", data.NewsletterEmail);

            const response = await axios.post(
                removeDoubleSlashes(
                    `${process.env.NEXT_PUBLIC_MOTORPOINT_URL}/newslettersignup/submit`
                ),
                form,
                {
                    headers: {
                        accept: "*/*",
                        "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
                    },
                }
            );
            setError(false);
            axiosOnSuccessEvent(response);
        } catch (error) {
            setError(true);
            return;
        }
    };

    return { handleAPICall, error };
};

export default useEmailSignup;
